import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: [],
    member: [],
    isLoading: false,
    error: false
};

const authSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        userRequest: (state) => {
            // console.log('userRequest payload ', state);
            state.isLoading = true;
            state.error = false;
        },
        setLoginUser: (state, action) => {
            // console.log('contact payload ', action.payload);
            state.user = action.payload;
        },
        setLoginMember: (state, action) => {
            // console.log('contact payload ', action.payload);
            state.member = action.payload;
        },
        setUsererror: (state, action) => {
            // console.log('error payload ', action.payload);
            state.error = action.payload;
        },
        clearUser: (state) => {
            state.user = [];
        },
        clearMember: (state) => {
            state.member = [];
        }
    },
});


export const { userRequest, setLoginUser, setLoginMember, setUsererror, clearUser, clearMember } = authSlice.actions;

export default authSlice.reducer;